module.exports = __webpack_public_path__ + "media/cortina/guia-izq-alacolumna-6f47a762.png";